<div *ngIf="sponsorLogoUrl" class="product-sponsor-logo">
  <img
    class="product-sponsor-logo-img"
    [src]="sponsorLogoUrl"
    alt=""
    (error)="onImageError()"
  />
</div>
